<template>
    <div id="foot"> 
        <router-link :class="home" to="/index"><i class="iconfont icon-shouye"></i><br>首页</router-link>
        <router-link :class="cart" to="/cart"><i class="iconfont icon-gouwuche"></i><br>购物车</router-link>
        <router-link :class="user" to="/user"><i class="iconfont icon-wode"></i><br>我的</router-link> 
    </div>
</template>
<style>
#foot{
    position:fixed;
    bottom: 0px;
    width: 100%;
    /* height: 3rem; */
    background-color: #fff;
    border-top:1px solid #ccc;
}

#foot a{
    text-decoration: none;
    display: inline-block;
    width: 33.333%;
    text-align: center;
    padding-top: .5rem;
    padding-bottom: .5rem;
    /* height: 3.2rem; */
    color: #666;
    font-size:0.8rem;
}
#foot .on{
    color: #e60012;
    /* color: #fd6d6d; */
    /* color:rgb(245, 71, 193); */
    /* color: rgba(255, 96, 96, 0.9); */
}

#foot a .iconfont{
    font-size: 1.2rem;
}
</style>
<script>
export default {
    data(){
        return {
            home:'',
            cart:'',
            user:'',
        }
    },
    mounted()
	{
		// console.log('-----');
		// console.log(this.$route.name);

        // this.home="";
        // this.cart="";
        // this.user="";
			
        if( this.$route.name=='/' || this.$route.name=='index')
        { 
            this.home="on"
        }
        if( this.$route.name=='cart' )
        {
            this.cart="on"
        }
        if( this.$route.name=='user' )
        {
            this.user="on"
        }
    }
}
</script>